import { useEffect, useState } from 'react'

export default function usePoll(fn, interval) {
    const [result, setResult] = useState(null)
    const [startPoll, setStartPoll] = useState(false)
    
    useEffect(() => {
        if (!startPoll) return;

        const execute = async () => {
            const res = await fn()
            setResult(res)
        } 

        execute()

        const id = setInterval(execute, interval)
        return () => clearInterval(id); // clean-up: prevents multiple polls in the same component
    }, [fn, interval, startPoll])

    const start = () => setStartPoll(true)
    const stop = () => setStartPoll(false)     

    return { result, start, stop };
}